// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml from "../../../../../../node_modules/rescript/lib/es6/caml.js";
import * as Belt_List from "../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as TicketRaisedBy from "../../app/tickets/entities/TicketRaisedBy.bs.js";
import * as Timestamp$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";

function sortCaseCommentsByCreatedAtAsc(comments) {
  return Belt_List.sort(comments, (function (a, b) {
                return Caml.caml_float_compare(Timestamp$Catalyst.toFloat(a.created_at), Timestamp$Catalyst.toFloat(b.created_at));
              }));
}

function getVm(ticket) {
  var raisedBy = ticket.raised_by;
  var match = ticket.issue_brief;
  return {
          order: {
            crn: ticket.crn,
            msisdn: ticket.msisdn,
            mobile: ticket.mobile,
            geo_region: Belt_Option.getWithDefault(ticket.geo_region, "NA")
          },
          ticket: {
            case_number: ticket.case_number,
            status: ticket.status,
            ticket_type: ticket.ticket_type,
            raised_at: ticket.raised_at,
            raised_by: raisedBy !== undefined ? TicketRaisedBy.toString(raisedBy) : "NA",
            author: ticket.author,
            escalate_to: ticket.escalate_to,
            order_stage: ticket.order_stage,
            issues: ticket.issues,
            actions: ticket.actions
          },
          comments: {
            action_comment: ticket.action_comment,
            issue_comment: ticket.issue_comment
          },
          case_comments: {
            comments: match !== undefined ? sortCaseCommentsByCreatedAtAsc(ticket.case_comments) : ticket.case_comments
          },
          issue_brief: ticket.issue_brief
        };
}

export {
  sortCaseCommentsByCreatedAtAsc ,
  getVm ,
  
}
/* Timestamp-Catalyst Not a pure module */
